import { useMutation } from "@tanstack/react-query";
import apis from "#store/api";

export const useBadgesPdf = () =>
  useMutation({
    mutationFn: async (badgeIds: string[]) => {
      const response = await apis.badges.getPdf({ params: { badgeIds } });
      return response.data as Blob;
    }
  });
  
export const useTeamBadgePdf = () =>
  useMutation({
    mutationFn: async ({ usarTeamNumber, incidentId }: { usarTeamNumber: number; incidentId: string }) => {
      const response = await apis.badges.getTeamBadge({
        params: { usarTeamNumber, incidentId }
      });
      return response.data as Blob;
    }
  });
